export const NATIVE_CHAIN_TOKENS = [{
        chainType: 'ethereum',
        network: 'mainnet',
        chainId: 1,
        nativeSymbol: 'eth'
    }, {
        chainType: 'ethereum',
        network: 'kovan',
        chainId: 42,
        nativeSymbol: 'eth'
    }, {
        chainType: 'moon',
        network: 'moonbeam',
        chainId: 1284,
        nativeSymbol: 'glmr'
    }, {
        chainType: 'moon',
        network: 'moonbase-alphanet',
        chainId: 1287,
        nativeSymbol: 'dev'
    }];
